import {Component} from '@angular/core';
import {Block}     from "../../block";

@Component({
    selector   : 'app-ratecard',
    templateUrl: './ratecard.component.html',
})
export class RatecardComponent extends Block {

}
